import clsx from 'clsx'

export function FilterInputToggle({ label, checked, onToggle, disabled }) {
  return (
    <button
      type="button"
      role="switch"
      aria-checked={checked}
      disabled={disabled}
      onClick={onToggle}
      className="flex items-center justify-between gap-4 w-full min-h-[56px] md-max:px-4 py-2 disabled:cursor-not-allowed disabled:opacity-50"
    >
      <span>{label}</span>
      <span
        aria-hidden="true"
        className={clsx(
          'shrink-0 relative w-8 h-4 rounded-full transition-colors',
          checked ? 'bg-primary-black' : 'bg-neutrals-medium-grey'
        )}
      >
        <span
          className={clsx(
            'absolute top-0.5 left-0.5 size-3 rounded-full bg-primary-white transition-all',
            checked && 'left-auto right-0.5'
          )}
        />
      </span>
    </button>
  )
}
